import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import NoPaymentLinksImg from "../../../assets/images/payments/no-payment-links.png";
import APP_ROUTES from "../../../routers/routeConstants";
import { PaymentCreatePaymentLinkIcon } from "../../../assets/icons/MUI/PaymentIcons";

const NoPaymentLinksFigure = ({ disableCanCreatePaymentLink }: { disableCanCreatePaymentLink: boolean }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "16px",
        alignItems: "center",
      }}
    >
      <img src={NoPaymentLinksImg} width="240px" height="180px" />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          component="h3"
          sx={{
            color: "var(--Gray-900, #101828)",
            fontFamily: "Montserrat",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "30px",
          }}
        >
          {t("pages.payment.paymentLinks.noPaymentLinksYet")}
        </Typography>
        <Typography
          component="p"
          sx={{
            color: "var(--Gray-600, #475467)",
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "20px",
            marginBottom: "24px",
          }}
        >
          {t("pages.payment.paymentLinks.youDidntCreatePaymentLinks")}
        </Typography>
        <Button
          variant="primary-md"
          onClick={() => navigate(APP_ROUTES.CREATE_PAYMENT_LINK)}
          startIcon={<PaymentCreatePaymentLinkIcon />}
          disabled={disableCanCreatePaymentLink}
        >
          {t("pages.payment.paymentLinks.createPaymentLink")}
        </Button>
      </Box>
    </Box>
  );
};

export default NoPaymentLinksFigure;
